/**
 * Carries the BFF base URL (`authUrl` prop) down to hooks that need to call
 * BFF endpoints directly (`useLogoutFunction`).
 *
 * `UseAuthInfoProps` is the seam's public type and must not be extended with
 * provider-specific fields, so this context is a private implementation
 * detail of the keycloak provider package.
 */
import { createContext } from 'react'

export const AuthUrlContext = createContext<string>('')
